var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"always"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Importação de destinatários")])]),_c('div',[_c('ImportDelivery')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }